// extracted by mini-css-extract-plugin
module.exports = {"list":"StepsDesktop_list__3lS4O","active":"StepsDesktop_active__jhwao","disabled":"StepsDesktop_disabled__3Bt7s","stepIcon":"StepsDesktop_stepIcon__1Nus3"};